module.exports = __webpack_public_path__ + "img/icon-loader-ccb2.aa6909cc.svg";